import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import Field                from '../../Field';

let Quote = require('../../Managers/Quote.js');

class Independent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isIndependentBankStatementNeeded: false,
            isIndependentFinancialStatementNeeded: false,
            isIndependentTaxReturnNeeded: false,
            isIndependentUploadLaterModalVisible: false,
        };
        this.inputComponents = [];
    }

    componentWillUpdate() {
        this.inputComponents = [];
    }

    componentWillUnmount() {
        this.inputComponents = [];
    }

    handleIndependentMethod(v) {
        this.setState({ isIndependentBankStatementNeeded: false });
        this.setState({ isIndependentFinancialStatementNeeded: false });
        this.setState({ isIndependentTaxReturnNeeded: false });
        Quote.set('financialRefereeType', 5, this.props.source);
        if (v === 99) {
            this.setState({ isIndependentBankStatementNeeded: true });
        }
        if (v === 98) {
            this.setState({ isIndependentFinancialStatementNeeded: true });
        }
        if (v === 5) {
            this.setState({ isIndependentTaxReturnNeeded: true });
        }
    }

    getChildInputComponents() {
        let inputComponents = this.inputComponents;
        inputComponents = inputComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        });
        return inputComponents;
    }

    render() {
        return(
            <div className="question-section" id={this.props.source}>
                <question-row class="header-row">
                    <h2>Independent Means</h2>
                    <p>We'll need to verify your savings or investments to complete your application.</p>
                </question-row>

                <Field
                    fieldName={'gross_income'}
                    question="Your annual income"
                    storageKey="grossIncome"
                    type="money"
                    hasBorder={false}
                    hasPadding={false}
                    dataValidation="2_decimal_money"
                    source={'BaseIndividualApplication'}
                    loadValues={true}
                    loadingKey={'BaseIndividualApplication.grossIncome'}
                    ref={(instance) => {this.inputComponents.push(instance);}}
                />

                {/* NOT Xpress - ask for evidence */}
                {this.props.productId !== 11 ?
                    <div>
                        <Field
                            question="How will you be providing evidence of this?"
                            fieldName={'method'}
                            type="button-choice"
                            options={[
                                {
                                    value: 99,
                                    text: 'Bank Statement'
                                },
                                {
                                    value: 98,
                                    text: 'Financial Statements'
                                },
                                {
                                    value: 5,
                                    text: 'Self Assessment tax return'
                                }
                            ]}
                            callbackFunction={this.handleIndependentMethod.bind(this)}
                            hasBorder={false}
                            hasPadding={false}
                            dataValidation="required_field"
                            source={'BaseIndividualApplication'}
                            ref={(instance) => {this.inputComponents.push(instance);}}
                            storageKey={"independentMeansEvidence"}
                            loadValues={true}
                            loadingKey={'BaseIndividualApplication.independentMeansEvidence'}
                        />

                        {this.state.isIndependentBankStatementNeeded ?
                            <Field
                                fieldName={'bank_evidence'}
                                question="Upload bank statements"
                                storageKey="evidence"
                                labelExtra={'Your statements must clearly show your name and the balance throughout the last 30 days, including dates. You can upload your evidence now below, or later upon completion of this form.'}
                                type="upload"
                                contextInfo={'Independent bank statement evidence'}
                                allowFileUploads={true}
                                allowCameraUploads={true}
                                source={'BaseIndividualApplication'}
                            />
                        : null}

                        {this.state.isIndependentFinancialStatementNeeded ?
                            <Field
                                fieldName={'financial_evidence'}
                                question="Upload financial statements"
                                storageKey="evidence"
                                labelExtra={'You can upload your evidence now below, or later upon completion of this form.'}
                                type="upload"
                                contextInfo={'Independent financial statement evidence'}
                                allowFileUploads={true}
                                allowCameraUploads={true}
                                source={'BaseIndividualApplication'}
                            />
                        : null}

                        {this.state.isIndependentTaxReturnNeeded ?
                            <Field
                                fieldName={'tax_evidence'}
                                question="Upload Self Assessment tax return"
                                storageKey="evidence"
                                labelExtra={'<p>Your Self Assessment tax return must have been completed and submitted to the inland revenue, partially completed tax returns will be rejected.</p><p>You can upload your evidence now below, or later upon completion of this form.</p>'}
                                type="upload"
                                contextInfo={'Independent tax return evidence'}
                                allowFileUploads={true}
                                allowCameraUploads={true}
                                source={'BaseIndividualApplication'}
                            />
                        : null}
                    </div>
                : null }
            </div>
        );
    }
}

Independent.propTypes = {
    productId:                  PropTypes.number.isRequired,
    source:                     PropTypes.string.isRequired,
    financialRefereeStatus:     PropTypes.oneOf([1, 2, 3]),
};

export default Independent;



// WEBPACK FOOTER //
// ./src/components/Screens/Sections/Independent.js